import { render, staticRenderFns } from "./rightsInfo.vue?vue&type=template&id=1d1e6238&scoped=true&lang=html&"
import script from "./rightsInfo.vue?vue&type=script&lang=js&"
export * from "./rightsInfo.vue?vue&type=script&lang=js&"
import style0 from "./rightsInfo.vue?vue&type=style&index=0&id=1d1e6238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1e6238",
  null
  
)

export default component.exports